const formatField = (value) => {
    return Array.isArray(value) ? value.join(', ') : value;
};

export default formatField;